import React from "react";
import { Container, Typography } from "@mui/material";

const RefundPolicy = () => (
  <Container sx={{ mt: 4 }}>
    <Typography variant="h4" gutterBottom>Refund Policy</Typography>

    <Typography variant="body1" paragraph>
      Last updated: 2025-09-12
    </Typography>

    <Typography variant="body1" paragraph>
      At HPHT Technology, customer satisfaction is a priority. We strive to ensure
      a smooth and reliable vending experience. However, we understand that issues may
      occasionally arise. Please review our refund policy below.
    </Typography>

    <Typography variant="h6" gutterBottom>Eligibility for Refund</Typography>
    <Typography variant="body1" paragraph>
      You may be eligible for a refund if:
      <ul>
        <li>Your payment was successful, but the vending machine did not dispense your item.</li>
        <li>You were charged multiple times for the same transaction.</li>
      </ul>
    </Typography>

    <Typography variant="h6" gutterBottom>Non-Refundable Cases</Typography>
    <Typography variant="body1" paragraph>
      Refunds will not be issued for:
      <ul>
        <li>Buyer's remorse or change of mind.</li>
        <li>Expired or misused QR codes.</li>
        <li>Incorrect product selection.</li>
      </ul>
    </Typography>

    <Typography variant="h6" gutterBottom>Refund Process</Typography>
    <Typography variant="body1" paragraph>
      To initiate a refund, please contact us with the following details:
      <ul>
        <li>Session ID (provided after payment)</li>
        <li>Time and location of transaction</li>
        <li>Screenshot of payment (if available)</li>
      </ul>
      All refund requests will be reviewed within 3 business days. Approved refunds will be processed via Razorpay to the original payment method within 7–10 business days.
    </Typography>

    <Typography variant="body1" paragraph>
      For assistance, contact us at <strong>sales@hphttech.com</strong>.
    </Typography>
  </Container>
);

export default RefundPolicy;